// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"officer_wrapper__2yAVz","tableWrapper":"officer_tableWrapper__2t0Iu"};